export const AUTH_MODE = {
  DEFAULT: 'DEFAULT',
  NORMAL: 'NORMAL',
  REGISTER: 'REGISTER',
  AUTOLOGIN: 'AUTOLOGIN',
  SSO: 'SSO',
  MFA: 'MFA',
};
